export default "/assets/images/mila-room-showcase-sm-01.f31024b4ca8a0d88.jpg";